/**
 * @file useCabinetDensity.ts
 * @description Плотность «склад» для экрана кладовщика (phase19.31, SC30,
 * SC44).
 *
 * Каркас кабинета магазина включает `data-density="warehouse"` на <html>,
 * пока открыт экран кладовщика (выбор — по роли, `isWarehouseMode`).
 * Крупные размеры 56px из атрибута действуют ТОЛЬКО до 1024px — это задаёт
 * медиазапрос в `styles/console-rules.css`; с 1024 и у остальных ролей —
 * стандарт 44/48. На <html>, а не на обёртке: диалоги и списки в порталах
 * тоже должны стать крупными.
 */

import { useLayoutEffect } from "react";

export const DENSITY_ATTR = "data-density";

export function useCabinetDensity(warehouse: boolean): void {
  useLayoutEffect(() => {
    const root = document.documentElement;
    if (!warehouse) {
      root.removeAttribute(DENSITY_ATTR);
      return;
    }
    root.setAttribute(DENSITY_ATTR, "warehouse");
    return () => root.removeAttribute(DENSITY_ATTR);
  }, [warehouse]);
}
